import { render, staticRenderFns } from "./practiceInfo.vue?vue&type=template&id=6cb9b811&scoped=true&"
import script from "./practiceInfo.vue?vue&type=script&lang=js&"
export * from "./practiceInfo.vue?vue&type=script&lang=js&"
import style0 from "./practiceInfo.vue?vue&type=style&index=0&id=6cb9b811&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb9b811",
  null
  
)

export default component.exports